import { render, staticRenderFns } from "./pageComponent.vue?vue&type=template&id=74b13e8e&scoped=true&"
import script from "./pageComponent.vue?vue&type=script&lang=js&"
export * from "./pageComponent.vue?vue&type=script&lang=js&"
import style0 from "./pageComponent.vue?vue&type=style&index=0&id=74b13e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b13e8e",
  null
  
)

component.options.__file = "pageComponent.vue"
export default component.exports